import { createSlice } from '@reduxjs/toolkit'
import { FormattedMessage } from "react-intl";

export const apiStore = createSlice({
    name: 'api-store',
    initialState: {
        // 默认api展示
        modulesList: [
            "event",
            'NousRobot',
            "servo",
            "screen",
            // "action",
            "sound",
            "music",
            "vision",
            "sensor",
            "AI",
        ],
        modulesType: null,
        variableList: [{
                name: 'get_tof_distance',
                index: 0
            }, {
                name: 'get_roll',
                index: 0
            }
            // , {
            //     name: 'get_pitch',
            //     index: window.peripheral && window.peripheral._sensors.tempoValue ? window.peripheral._sensors.tempoValue : 0
            // }, {
            //     name: 'get_yaw',
            //     index: window.peripheral && window.peripheral._sensors.soundIntensity ? window.peripheral._sensors.soundIntensity : 0
            // }
        ]
    },
    reducers: {
        setModules: (state, action) => {
            state.modulesList = action.payload
        },
        setModulesType: (state, action) => {
            state.modulesType = action.payload
        },
        setVariableList: (state, action) => {
            state.variableList[0].index = action.payload.distance
            state.variableList[1].index = action.payload.soundIntensity
                // state.variableList[2].index = action.payload.tempoValue
                // state.variableList[3].index = action.payload.soundIntensity
        }
    }
})

export const {
    setModules,
    setModulesType,
    setVariableList
} = apiStore.actions
export default apiStore.reducer